import { z } from 'zod'

export const zDiscountRowTypeEnum = z
  .enum([
    'Appropriation',
    'GreenOrdination',
    'AgreementGroup',
    'CampaignPart',
    'CampaignSalesPromotionPart',
    'CampaignSalesPromotionNode',
  ])
  .nullable()

export type DiscountRowTypeEnumSchema = z.infer<typeof zDiscountRowTypeEnum>
